"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAuthenticator = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "MbAuthenticator", { enumerable: true, get: function () { return features_1.MbAuthenticator; } });
//# sourceMappingURL=index.js.map